export default __webpack_public_path__ + "static/media/section-about-img-1.72ef8b8e.png";